export default __webpack_public_path__ + "static/media/bloodforaid3.0a76a82d.png";